module.exports = {"unesco":["Mediekunnighet","Informationskunnighet","Bibliotekskunnighet","Yttrandefrihets- och informationsfrihetskunnighet","Digital kunnighet","Datorkunnighet","Internetkunnighet","Spelkunnighet","Filmkunnighet","TV-kunnighet","Nyhetskunnighet","Reklamkunnighet"]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/notions.json
// module id = 2z9x
// module chunks = 1